import StandardLayout from "./StandardLayout";

export  { StandardLayout };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/StandardLayout/index.tsx